import React from 'react';
import { get } from 'lodash/fp';
import { Table } from 'rsuite';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import S3Image from '../../../S3Image';

const { Cell } = Table;

const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border-radius: 20px;
  margin-top: 2px;
  overflow: hidden;
  display: inline-block;
`;

const ImageCell = ({ rowData, dataKey, bucket, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <ImageWrapper>
      <S3Image
        bucket={bucket}
        image={get(dataKey, rowData)}
        style={{ width: 40 }}
      />
    </ImageWrapper>
  </Cell>
);

ImageCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  bucket: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

ImageCell.defaultProps = {
  rowData: null
};

export default ImageCell;
